import { instance } from 'api/internaltools';

export const getFilteredMerchants = (params) => {
  return instance.get('/filtered-merchants', { params });
};

export const updateMerchantName = (payload) => {
  return instance.patch('/merchant/name', payload);
};

export const createManualPayoutSession = (payload) => {
  return instance.post('/manual-payout-session', payload);
};
